import * as React from "react";
import type { SVGProps } from "react";
const SvgCocktail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#cocktail_svg__a)">
      <path d="M16 22H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M12 22c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1" />
      <path d="M12 15c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l7-7a.996.996 0 1 1 1.41 1.41l-7 7c-.2.2-.45.29-.71.29z" />
      <path d="M12 15c-.26 0-.51-.1-.71-.29l-7-7A.996.996 0 1 1 5.7 6.3l7 7a.996.996 0 0 1-.71 1.7z" />
      <path d="M19 8H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M11 10c-.37 0-.72-.2-.9-.55l-2.99-6a.993.993 0 0 1 .45-1.34c.5-.25 1.1-.05 1.34.45l3 6c.25.49.05 1.09-.45 1.34-.14.07-.3.11-.45.11z" />
      <path d="M8 4H3c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1M18 12c-.88 0-1.74-.23-2.5-.67a1 1 0 0 1-.36-1.37c.28-.48.89-.64 1.37-.36.45.26.97.4 1.5.4 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .55-.45 1-1 1s-1-.45-1-1c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5z" />
    </g>
    <defs>
      <clipPath id="cocktail_svg__a">
        <path fill="#fff" d="M2 2h21v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCocktail;
